import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import "./signup.css"; // renamed file
import ppp from "../Images/signup.webp";
import { Link, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

const Signup = () => {
  const [value, setValue] = useState({
    username: "",
    email: "",
    phoneNumber: "",
    password: "",
    confirmPassword: "",
  });
  const [passwordStrength, setPasswordStrength] = useState("");
  const [terms, setTerms] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleTermsChange = () => {
    setTerms(!terms);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValue((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    if (name === "password") {
      setPasswordStrength(getPasswordStrength(value));
    }
  };

  const getPasswordStrength = (password) => {
    if (
      password.length >= 8 &&
      /[A-Z]/.test(password) &&
      /[a-z]/.test(password) &&
      /\d/.test(password) &&
      /[^A-Za-z0-9]/.test(password)
    ) {
      return "strong";
    } else if (password.length >= 6) {
      return "moderate";
    } else {
      return "weak";
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (value.password !== value.confirmPassword) {
      toast.error("Passwords do not match!");
      setLoading(false);
      return;
    }

    if (!terms) {
      toast.warn("Please accept the terms and conditions.");
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post(
        "https://api.litaxfilers.com/signUp",
        {
          username: value.username,
          email: value.email,
          phoneNumber: value.phoneNumber,
          password: value.password,
          terms,
        }
      );

      if (response.status === 200) {
        toast.success("Registration successful. Check your email for details!");
        navigate("/login");
      }
    } catch (error) {
      if (error.response && error.response.status === 409) {
        toast.info("User already registered. Please log in.");
      } else {
        console.error("Error during registration:", error);
        toast.error("Something went wrong. Please try again later.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="register-container">
      <div className="register-box">
        {/* Left Image Section */}
        <div className="register-image">
          <img
            src={ppp}
            alt="Signup Illustration"
            className="register-image-content"
          />
        </div>

        {/* Right Content Section */}
        <div className="register-content">
          <Link to="/" className="register-back-link">
            <FaArrowLeft size={14} style={{ marginRight: "8px" }} /> Back to
            Home
          </Link>

          <h1 className="register-heading">Register</h1>

          <form onSubmit={handleSubmit} className="register-form">
            <div className="register-field">
              <input
                type="text"
                placeholder="Username"
                name="username"
                value={value.username}
                onChange={handleChange}
                required
              />
            </div>
            <div className="register-field">
              <input
                type="email"
                placeholder="Email"
                name="email"
                value={value.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="register-field">
              <input
                type="text"
                placeholder="Phone Number"
                name="phoneNumber"
                value={value.phoneNumber}
                onChange={handleChange}
                required
              />
            </div>
            <div className="register-field">
              <input
                type="password"
                placeholder="Password"
                name="password"
                value={value.password}
                onChange={handleChange}
                required
              />
            </div>

            {/* Password Strength */}
            <div className="register-password-strength">
              {passwordStrength === "strong" && (
                <p style={{ color: "green" }}>Password strength: Strong</p>
              )}
              {passwordStrength === "moderate" && (
                <p style={{ color: "orange" }}>Password strength: Moderate</p>
              )}
              {passwordStrength === "weak" && (
                <p style={{ color: "red" }}>Password strength: Weak</p>
              )}
            </div>

            <div className="register-field">
              <input
                type="password"
                placeholder="Confirm Password"
                name="confirmPassword"
                value={value.confirmPassword}
                onChange={handleChange}
                required
              />
            </div>

            <div className="register-terms">
              <input
                type="checkbox"
                checked={terms}
                onChange={handleTermsChange}
                id="terms"
              />
              <label htmlFor="terms">
                I agree to the{" "}
                <a href="/terms" target="_blank" rel="noopener noreferrer">
                  Terms and Conditions
                </a>
              </label>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="register-button"
            >
              {loading ? "Signing Up..." : "Sign Up"}
            </button>

            <p className="register-footer">
              Already have an account?{" "}
              <Link to="/login" className="register-link">
                Login
              </Link>
            </p>
          </form>
          <ToastContainer />
        </div>
      </div>
    </div>
  );
};

export default Signup;
